import React from "react";
import { CreditCardIcon, LayersIcon } from "lucide-react";
import { WhatsAppIcon } from "./icons/BrandIcons";
import { links } from "../data/content";
const base = "inline-flex w-full items-center justify-center gap-2.5 rounded-[10px] px-6 py-4 text-[15px] font-bold whitespace-nowrap transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-base";
type CtaButtonsProps = {
  className?: string;
};
export function CtaButtons({
  className = "mx-auto"
}: CtaButtonsProps) {
  return <div className={`flex w-full max-w-[420px] flex-col items-stretch gap-3.5 ${className}`} data-id="element-11" data-mp="2cvyazhzf0nfg">
      <a href={links.skool} target="_blank" rel="noopener noreferrer" className={`${base} bg-gold text-black hover:bg-gold-light focus-visible:ring-gold`} data-id="element-12" data-mp="2gvyql5y934o3">
        <LayersIcon className="h-5 w-5" aria-hidden="true" data-id="element-13" data-mp="27u90c3g3ubrw" />
        Unirme a Radar Digital — $27/mes
      </a>
      <div data-id="element-14" data-mp="1npwx21srkeu3">
        <a href={links.mercadopago} target="_blank" rel="noopener noreferrer" className={`${base} bg-mp text-white hover:bg-mp-dark focus-visible:ring-mp`} data-id="element-15" data-mp="1npn3y5cf9rk6">
          <CreditCardIcon className="h-5 w-5" aria-hidden="true" data-id="element-16" data-mp="1rpe2wwc3rdzs" />
          Pagar en pesos — $40.000 ARS/mes
        </a>
        <p className="mt-2 text-center text-xs text-muted" data-id="element-17" data-mp="13zbcslrr0i3t">
          Solo para Argentina · Suscripción con Mercado Pago
        </p>
      </div>
      <a href={links.whatsapp} target="_blank" rel="noopener noreferrer" className={`${base} bg-wa text-white hover:bg-wa-dark focus-visible:ring-wa`} data-id="element-18" data-mp="1002nbt3qr6e2">
        <WhatsAppIcon className="h-5 w-5" data-id="element-19" data-mp="18xd0jk04d5lm" />
        Sumarme al grupo de WhatsApp gratis
      </a>
    </div>;
}